import { useForm } from 'react-hook-form';
import Button from 'components/Common/Button';
import Switch from 'components/Common/Switch';
import { FaExclamationTriangle } from 'react-icons/fa';
import { Box, Typography, Paper } from '@mui/material';
import AccessControlIcon from 'assets/icons/AccessControlIcon';
import { useGetAgencyConfiguration, useUpdateAgencyConfiguration } from 'apis/agency/configuration/hook';

const Access = () => {
  const { data: configuration } = useGetAgencyConfiguration();
  const { mutateAsync: updateConfiguration, isPending: updatingConfigs } = useUpdateAgencyConfiguration();
  const { control, handleSubmit, watch } = useForm({
    values: {
      configuration: configuration
    }
  });
  const isAccessGiven = watch('configuration.access_enabled');
  const onSubmit = (data: any) => {
    updateConfiguration(data);
  };

  return (
    <Box p={4}>
      <Typography variant='h5' fontWeight='bold' display='flex' alignItems='center' gap={1} mb={1}>
        <AccessControlIcon /> Business Access Control
      </Typography>
      <Typography variant='body2' color='text.secondary' mb={2}>
        Configure how new businesses can access your platform.
      </Typography>

      <Paper elevation={0} sx={{ p: 3, borderRadius: 2, border: '1px solid #f3f3f3' }}>
        <Box display='flex' justifyContent='space-between' alignItems='center' mb={3}>
          <Box>
            <Typography fontWeight='600'>Auto-Approve Business Access</Typography>
            <Typography color='text.secondary' fontSize={14}>
              When enabled, new businesses can access the platform immediately after signup. When disabled, agency owner
              approval is required.
            </Typography>
          </Box>
          <Switch name='configuration.access_enabled' control={control} />
        </Box>
        {!isAccessGiven && (
          <Box
            sx={{
              backgroundColor: 'rgb(255, 251, 235)',
              border: '1px solid rgb(255, 251, 235)',
              borderRadius: 2,
              p: 1,
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1
            }}
          >
            <Box sx={{ width: '100%' }}>
              <Box display='flex'>
                <Box
                  component='span'
                  sx={{
                    width: 24,
                    height: 24,
                    mt: '2px',
                    color: 'rgb(146,64,14,0.69)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <FaExclamationTriangle />
                </Box>
                <Typography fontWeight={600} mt='2px' color='rgb(146,64,14,0.69)'>
                  Manual Approval Required
                </Typography>
              </Box>
              <Typography variant='body2' color='rgb(146,64,14,0.69)'>
                New businesses will need to wait for your approval before accessing the platform. You'll receive
                notifications when new businesses sign up.
              </Typography>
            </Box>
          </Box>
        )}
      </Paper>

      <Box display='flex' justifyContent='flex-end' gap={2} mt={4}>
        <Button variant='contained' isPending={updatingConfigs} color='primary' onClick={handleSubmit(onSubmit)}>
          Save Configuration
        </Button>
      </Box>
    </Box>
  );
};

export default Access;
